module.exports = __webpack_public_path__ + "img/1-2.5f2b57fb.jpg";